"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var convertListToArray_1 = __importDefault(require("../___utils/convertListToArray"));
var isType_1 = require("../___utils/isType");
var ScrollRenderer_1 = __importDefault(require("./ScrollRenderer"));
var uiFunctions_1 = require("./uiFunctions");
function PlainList(props) {
  var list = props.list,
    renderItem = props.renderItem,
    renderWhenEmpty = props.renderWhenEmpty,
    renderOnScroll = props.renderOnScroll,
    wrapperHtmlTag = props.wrapperHtmlTag,
    __forwarededRef = props.__forwarededRef,
    tagProps = __rest(props, ["list", "renderItem", "renderWhenEmpty", "renderOnScroll", "wrapperHtmlTag", "__forwarededRef"]);
  var dataList = (0, convertListToArray_1.default)(list);
  var renderThisItem = (0, react_1.useMemo)(function () {
    return (0, uiFunctions_1.handleRenderItem)(renderItem, null);
  }, [renderItem]);
  if (dataList.length === 0) {
    return (0, uiFunctions_1.renderBlank)(renderWhenEmpty);
  }
  var WrapperElement = "".concat((0, isType_1.isString)(wrapperHtmlTag) && wrapperHtmlTag ? wrapperHtmlTag : "");
  var content = react_1.default.createElement(react_1.default.Fragment, null, renderOnScroll ? react_1.default.createElement(ScrollRenderer_1.default, {
    list: dataList,
    renderItem: renderItem
  }) : dataList.map(renderThisItem));
  return react_1.default.createElement(react_1.default.Fragment, null, WrapperElement ?
  // @ts-ignore
  react_1.default.createElement(WrapperElement, __assign({}, tagProps, {
    ref: __forwarededRef
  }), content) : content);
}
exports.default = (0, react_1.forwardRef)(function (props, ref) {
  ref = ref || (0, react_1.createRef)();
  return react_1.default.createElement(PlainList, __assign({
    __forwarededRef: ref
  }, props));
});